import { render } from "./WaveSeparator.vue?vue&type=template&id=5ad0ffcd&scoped=true"
import script from "./WaveSeparator.vue?vue&type=script&lang=js"
export * from "./WaveSeparator.vue?vue&type=script&lang=js"

import "./WaveSeparator.vue?vue&type=style&index=0&id=5ad0ffcd&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ad0ffcd"]])

export default __exports__